<template>
    <div class="app-layout">
      <!-- Sidebar (remains constant) -->
      <div class="sidebar-container">
        <Sidebar />
      </div>
  
      <div class="content-container">
        <router-view />
      </div>
    </div>
  </template>
  
  <script>
  import Sidebar from '@/components/AppSidebar.vue'; // Sidebar component
  
  export default {
    name: 'AppLayout',
    components: {
      Sidebar
    }
  };
  </script>
  
  <style scoped>
  .app-layout {
    display: flex;
    height: 100vh; /* Full viewport height */
  }
  
  .sidebar-container {
    width: 250px;
  }
  
  .content-container {
    flex-grow: 1;
    padding: 20px;
    overflow-y: auto;
    
  }
  </style>
  